/**
 * Internal / agent-facing tool failures that `renderToolUse` must skip before
 * any specialized adapter. Keep this to the two exact backend strings that
 * predate the structured-code allowlist — generic rows already hide everything
 * else via `isClinicianActionableToolError`.
 */
export const isNonActionableToolError = (raw: string | undefined): boolean => {
  const text = raw?.trim();
  if (!text) return false;
  return (
    text.toLowerCase() === 'not found or unauthorized.' ||
    (/^Tool ['"][^'"]+['"] is not available in this run\./.test(text) &&
      text.includes('Available tools:'))
  );
};
